import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Config } from 'protractor';
import { config } from 'rxjs';
import { ConfigKeys } from '../config/config.keys';

@Injectable()
export class LoginService{

  token: string;
  configKeys: ConfigKeys = new ConfigKeys();

  constructor(private httpClient: HttpClient) {}

    login(username: string, password: string){


      var data = new FormData();
      data.append('username', username);
      data.append('password', password);
        //------Invoke login method by POST--------
             var client = new XMLHttpRequest();
             // client.open('POST', this.configKeys.API_URL_LOGIN + 'username=' + username + '&password=' +  password, false);
             client.open('POST', this.configKeys.API_URL_LOGIN, false);
             client.send(data);
             var tokenAuth = client.getResponseHeader("Authorization");
             this.token = tokenAuth;
    }

    getIdToken() {
       return this.token;
    }

  isAutenticated() {
    return this.token != null;
  }

}
